import { render } from "./Sales.vue?vue&type=template&id=8ecd2a86&ts=true"
import script from "./Sales.vue?vue&type=script&lang=ts"
export * from "./Sales.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__